import { styled, Box, Stack } from '@mui/material';

export const NewAccountTabs = styled(Stack)((props) => ({
	margin: '1rem 0',
	position: 'relative',
	'& .mainTab': {
		flexDirection: 'row',
		justifyContent: 'space-between',
		padding: '0 12px',
		height: '48px',
		margin: '2px',
		'&:nth-child(1)': {
			borderRadius: '10px 10px 0 0',
			paddingRight: '18px',
		},
		'&.last': {
			borderRadius: '0 0 10px 10px',
		},
		backgroundColor: props.theme.palette.root.brandSecondary_014,
		'&.selected': {
			color: '#fff',
			//border:'1px solid red',
			backgroundColor: props.theme.palette.root.basicDeeoGreen,
			'&:hover': {
				background: props.theme.palette.root.basicDeeoGreen,
			},
		},
		'& .MuiButtonBase-root': {
			'&.Mui-disabled': {
				color: props.theme.palette.root.basicDeeoGreen,
			},
		},
	},
}));
